import { Component } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';

@Component({
  selector: 'app-date-picker',
  templateUrl: './date-picker.component.html',
  styleUrl: './date-picker.component.scss',
  imports: [
    MatDatepickerModule,
    MatCardModule,
  ],
})
export class DatePickerComponent extends FieldType<FieldTypeConfig> {
  readonly now = new Date();
}
